export default __webpack_public_path__ + "static/media/exploreFilledIcon.709aa454.svg";